import Link from "next/link"
import { ReactNode } from "react"
import styles from "./button.module.css"
interface ButtonProps {
  type: string
  url: string
  title: string
  target?: string
  icon?: ReactNode | boolean | string
}

function Button({ title, type, url, target }: ButtonProps) {
  return (
    <Link
      href={url}
      target={target}
      className={`${styles.button} ${
        type === "one"
          ? "before:bg-white rounded-full hover:text-white hidden xl:flex"
          : ""
      } ${
        type === "three"
          ? "before:bg-[--color-brand] text-[--color-dark]  hover:text-white rounded-sm "
          : ""
      }  flex w-full xl:w-fit items-center justify-center gap-4 text-[16px] xl:text-[24px] 3xl:text-[38px]  py-5 px-5 2xl:px-8 transition-all duration-300 ease-in-out `}
    >
      <span>{title}</span>
      {/* {icon === true ? <MoveRight /> : icon ? <span>{icon}</span> : null} */}
    </Link>
  )
}

export default Button
